import { Link } from 'react-router-dom';
import { manhwaList } from '@/mocks/manhwa';

export default function LatestUpdates() {
  const latest = [...manhwaList].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              每日追踪热门韩漫的最新章节
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((manhwa) => (
            <Link
              key={manhwa.id}
              to={`/article/${manhwa.slug}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={manhwa.cover}
                  alt={manhwa.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0 flex-1">
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {manhwa.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{manhwa.author}</p>
                </div>
                <div>
                  <span className="inline-block px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium mb-1">
                    {manhwa.status}
                  </span>
                  <p className="text-xs text-foreground-400">
                    更新于 {manhwa.updatedAt}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}